import React from 'react';

const TextTemplate = ({ data, value, tableManager }) => {
  const {
    config: {
      additionalProps: { cell: additionalProps = {} },
    },
  } = tableManager;

  const classNames = ('rgt-cell-inner rgt-text-truncate justify-content-center ' + (additionalProps.className || '')).trim();

  return (
    <>
      <span
        title={value}
        className={classNames}
      >
        {value == '0/0' ? 'N/A' : value}
      </span>
    </>
  );
};

export default TextTemplate;
